<div (click)="toggle()">
  <i class="material-icons" *ngIf="!isPlaying() || !isCurrentTrack()">play_arrow</i>
  <i class="material-icons" *ngIf="isPlaying() && isCurrentTrack()">pause</i>
  <span>{{song.title}}</span>
</div>
